<template>
  <div class="step-bar">
    <div v-for="(step, index) in steps" :key="index" @click="handleStepClick(index)" :class="{ 'step': true, 'active': index === currentStep, 'completed': index < currentStep }">
      <span class="step-number">{{ index + 1 }}</span>
      <span class="step-label">{{ step }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentStep: 3, // 当前步骤
      steps: ['Step 1', 'Step 2', 'Step 3', 'Step 4'], // 步骤列表
    };
  },
  methods: {
    handleStepClick(index) {
      // 只有当步骤是当前步骤的前一步时才允许点击
      if (index < this.currentStep) {
        this.currentStep = index; // 更新当前步骤
        console.log(`Clicked on Step ${index + 1}`);
      }
    },
  },
};
</script>

<style scoped>
.step-bar {
  display: flex;
}

.step {
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}

.step.active {
  background-color: #007bff;
  color: #fff;
}

.step.completed {
  background-color: #28a745;
  color: #fff;
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin-right: 10px;
  font-weight: bold;
  border: 2px solid #007bff;
}

.step-label {
  flex-grow: 1;
}
</style>
